import {ChangeDetectionStrategy, Component, Inject, Input, OnInit,} from '@angular/core';
import {Params} from '@angular/router';
import {NbTagComponent,} from '@nebular/theme';
import {FormlyFieldConfig} from '@ngx-formly/core';
import {BreadcrumbDto, DamElasticDTO, Picture, ProductCustomer, Role, StoreService} from 'compob2b-libs';
import {DefaultConfig} from 'compob2b-table';
import {Observable} from 'rxjs';
import {map, takeUntil, tap} from 'rxjs/operators';
import {translations} from '../../../../../environments/translations.ru';
import {ListComponent} from '../../../../admin-shared/crud-components/list/list.component';
import {CrudConfig} from '../../../../admin-shared/interfaces/crud.config';
import {RelatedEntity} from '../../../../admin-shared/interfaces/related.entity';

@Component({
  selector: 'app-basket-table',
  templateUrl: './basket-table.component.html',
  styleUrls: ['./basket-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BasketTableComponent extends ListComponent<BreadcrumbDto> implements OnInit {

  @Input() productList: Observable<DamElasticDTO[]>;
  @Input() catalogId: number;
  @Input() configURI: string;
  @Input() catalogBreadCrumbs: Observable<BreadcrumbDto[]>;
  isShowProductList = false;
  isShowProductTable = true;
  isShowProductTableMore = false;

  damElasticDTO: DamElasticDTO = null;
  conditionalBalance: boolean;
  supplier = translations.supplier;
  storeService = Inject(StoreService);
  productShow = false;
  configBatch: CrudConfig;
  allRoles: Role[];

  ngOnInit(): void {
    let damView = localStorage.getItem('damView');
    if (damView === undefined) {
      damView = 'table';
    }
    this.showProductBlocks(damView);
    this.conditionalBalance = this.storeService.getConditionalBalance();
    this.configuration = {...DefaultConfig};
    // ... etc.
    this.columns = [
      {key: 'phone', title: 'Phone'},
      {key: 'age', title: 'Age'},
      {key: 'company', title: 'Company'},
      {key: 'name', title: 'Name'},
      {key: 'isActive', title: 'STATUS'},
    ];

    const allRoles = this.compoApiService.get<Role[]>('/dam-menu/list-roles-for-batch/')
      .pipe(map(response => response.data), tap(data => this.allRoles = data));

    const relatedEntities: RelatedEntity[] = [
      {multipleEntity: allRoles, multipleField: 'rolesName'}
    ];

    this.configBatch = {
      uri: '/dam/',
      columns: [
        {
          key: 'forAll',
          className: 'col-3',
          title: translations.forAll,
          placeholder: translations.forAll,
          searchEnabled: false,
          formly: true,
          grid: true,
          orderEnabled: false,
          defaultValue: false,
          type: 'checkbox',
          required: true,
          templateOptions: {label: translations.forAll},
        },
        {
          key: 'operation',
          className: 'col-3',
          title: translations.operations,
          placeholder: translations.operations,
          orderEnabled: false,
          formly: true,
          defaultValue: 'none',
          type: 'select',
          templateOptions: {
            label: translations.operations,
            options: [
              {label: translations.selectOperations, value: 'none'},
              {label: translations.makeEnabled, value: 'enable'},
              {label: translations.makeDisable, value: 'disable'},
              {label: translations.dam.toApproved, value: 'approved'},
              {label: translations.dam.notApproved, value: 'notApproved'},
              {label: translations.damChangeAcl, value: 'changeAcl'},
            ],
          },
          width: '100%',
          grid: false
        },
        {
          key: 'deleteAction',
          className: 'col-3',
          title: '',
          placeholder: translations.delete,
          formly: true,
          type: 'checkbox',
          defaultValue: false,
          hideExpression: model => model.operation !== 'changeAcl',
          width: '100%',
          grid: false
        },
        {
          key: 'rolesName',
          className: 'col-3',
          title: translations.roles,
          placeholder: translations.roles,
          formly: true,
          type: 'select',
          templateOptions: {
            label: translations.roles,
            type: 'array',
            valueProp: 'name',
            labelProp: 'header'
          },
          expressionProperties: {
            'templateOptions.required': (model: any, formState: any, field: FormlyFieldConfig) => {
              return model.operation === 'changeAcl';
            },
          },
          hideExpression: model => model.operation !== 'changeAcl',
          width: '100%',
          grid: false
        },
        {
          key: 'changeAclMode',
          className: 'col-3',
          title: translations.changeModesLabel,
          placeholder: translations.changeModesLabel,
          orderEnabled: false,
          formly: true,
          defaultValue: 1,
          type: 'multicheckbox',
          templateOptions: {
            label: translations.changeModesLabel,
            options: [
              {label: translations.dam.read, value: 1},
              {label: translations.dam.write, value: 2},
              {label: translations.dam.administration, value: 16},
              {label: translations.dam.create, value: 4},
              {label: translations.dam.delete, value: 8},
            ],
          },
          hideExpression: model => model.operation !== 'changeAcl',
          expressionProperties: {
            'templateOptions.required': (model: any, formState: any, field: FormlyFieldConfig) => {
              return model.operation === 'changeAcl';
            },
          },
          width: '100%',
          grid: false
        },
      ],
      title: translations.operations,
      relatedEntity: relatedEntities,
      absolutePath: ''
    };
    this.formsConfig.setConfig(this.configBatch.columns).formly();

    relatedEntities.forEach(item => this.formsConfig.addMultipleOptions(item.multipleField, item.multipleEntity));

    this.formsConfig.setConfig(this.configBatch.columns).formly();
  }

  onTagRemove(tagToRemove: NbTagComponent): void {
    // this.trees = this.trees.filter(t => t !== tagToRemove.text);
  }

  openModalProduct(product: ProductCustomer): void {
    // if (product !== undefined) {
    //   this.storeService.nextCurrentProduct(product.syncUid);
    //   this.windowService.open(ModalProductComponent, {
    //     context: {
    //       productUid: product.syncUid
    //     }
    //   }).onClose.pipe(takeUntil(this.unsubscribe)).subscribe();
    // }
  }

  showProductBlocks(type: string) {
    if (type === 'list') {
      this.isShowProductList = true;
      this.isShowProductTable = false;
      this.isShowProductTableMore = false;
      this.productShow = false;
    } else if (type === 'table') {
      this.isShowProductList = false;
      this.isShowProductTable = true;
      this.isShowProductTableMore = false;
    } else if (type === 'more') {
      this.isShowProductList = false;
      this.isShowProductTable = false;
      this.isShowProductTableMore = true;
    }
    localStorage.setItem('damView', type);
  }

  showProductInfo(id, isImage, $event, countVersion) {
    this.compoApiService.get<DamElasticDTO>('/dam/' + id).pipe(takeUntil(this.unsubscribe)).subscribe(response => {
      this.productShow = $event;
      this.damElasticDTO = response.data;
      this.damElasticDTO.isImage = isImage;
      this.damElasticDTO.countVersion = countVersion;
      this.cdr.detectChanges();
    });

  }

  getImageUri(picture: Picture, width: number = 96) {
    return picture === null ? null : this.fileService.getImageSrc(picture.name + '.' + picture.type, 96);
  }

  hideProductInfo() {
    this.productShow = false;
  }

  changeSort($event) {
    console.log($event);
    const sortData = $event.split('_');
    const queryParams: Params = {sort: sortData[0], direction: sortData[1]};

    this.onNavigate(queryParams);
  }

}
